import { Button } from "primereact/button";

import { Dialog, DialogHeader } from "@/ds";

import styles from "./confirmar-simulacao-dialog.module.scss";
import type { ConfirmarSimulacaoDialogViewModel } from "./types-confirmar-simulacao-dialog";

export function ConfirmarSimulacaoDialogView({
  titulo,
  mensagem,
  confirmarLabel,
  cancelarLabel,
  testId,
  cancelarTestId,
  confirmarTestId,
  onConfirmar,
  onCancelar,
}: ConfirmarSimulacaoDialogViewModel) {
  return (
    <Dialog
      visible
      size="sm"
      onHide={onCancelar}
      header={<DialogHeader title={titulo} subtitle={mensagem} />}
      footer={
        <div className={styles.footer}>
          <Button
            type="button"
            label={cancelarLabel}
            severity="secondary"
            text
            onClick={onCancelar}
            data-testid={cancelarTestId}
          />
          <Button
            type="button"
            label={confirmarLabel}
            severity="danger"
            onClick={onConfirmar}
            data-testid={confirmarTestId}
          />
        </div>
      }
      data-testid={testId}
    />
  );
}
